import axiosInstance from './axios.instance';

const apiUrl = process.env.REACT_APP_API_URL;

export class ApiService {
  async get(url) {
    return await axiosInstance.get(apiUrl + url);
  }

  async post(url, data) {
    const response = await axiosInstance.post(apiUrl + url, data);
    return response.data
  }

  async update(url, data) {
    const response = await axiosInstance.put(apiUrl + url, data);
    return response.data;
  }

  async delete(url) {
    const response = await axiosInstance.delete(apiUrl + url);
    return response.data;
  }

  async patch(url, data) {
    const response = await axiosInstance.patch(apiUrl + url, data);
    return response.data;
  }
}

export const apiService = new ApiService();
